import { render, staticRenderFns } from "./TheSnackbarLoader.vue?vue&type=template&id=b37246da&scoped=true&"
import script from "./TheSnackbarLoader.vue?vue&type=script&lang=js&"
export * from "./TheSnackbarLoader.vue?vue&type=script&lang=js&"
import style0 from "./TheSnackbarLoader.vue?vue&type=style&index=0&id=b37246da&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b37246da",
  null
  
)

export default component.exports